import React, { useState, useEffect, useRef } from "react";

export const Header = (props) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1100);
  const [offsetY, setOffsetY] = useState(0);
  const headerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (isVisible) {
        setOffsetY(window.scrollY);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, []);

  const backgroundImage = props.data
    ? isSmallScreen
      ? props.data.imageS || "/img/defaultSmall.png"
      : props.data.imageB || "/img/defaultBig.png"
    : "/img/defaultFallback.png";

  const styles = {
    header: {
      position: "relative",
      width: "100%",
      height: "100vh",
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: `center ${-offsetY * (isSmallScreen ? 0.05 : 0.1)}px`,
    },
  };

  return (
    <header id="header" ref={headerRef}>
      <div style={styles.header}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 intro-text">
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
